import moment from 'moment';

export default function formatdate(value, format = 'YYYY-MM-DD HH:mm') {
  return moment(value).format(format);
}
